<app-header></app-header>
<div class="wrapper">
    <div class="page-content multi-slider">
        <div class="channelsgrid-timeline">
            <div class="timeline-day">
                <h6 class="text-center font-bold">
                    All Channels
                </h6>
            </div>
            <div class="timeline-greed">
                <div class="time-label">
                    12:00
                </div>
                <div class="time-label">
                    12:30
                </div>
                <div class="time-label">
                    1:00
                </div>
                <div class="time-label">
                    1:30
                </div>
                <div class="time-label">
                    2:00
                </div>
                <div class="time-label">
                    2:30
                </div>
                <div class="time-label">
                    3:00
                </div>
                <div class="time-label">
                    3:30
                </div>
            </div>
            <div class="channelsgrid-button">
                <button class="channelsgrid-btn" type="button">
                    <span class="mdi mdi-chevron-left"></span>
                </button>
                <button type="button" class="channelsgrid-btn">
                    <span class="mdi mdi-chevron-right"></span>
                </button>
            </div>
        </div>
        <div class="channelsgrid-body">
            <div class="channelsgrid-list-box">
                <div class="chanelshow-list">
                    <div class="channel-logo-box">
                        <div class="logo-img">
                            <img
                                src="https://media.unreel.me/prod/nosey/general/66701457-2ca4-4f5b-a02a-7117e8e9714d" />
                        </div>
                    </div>
                    <div class="channel-grid-row">
                        <div class="channel-grid-colm active" style="width: 320px;">
                            <h6 class="mb-1">
                                The Jerry Springer Show
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S1 <span class="dots"></span> E12
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 200px;">
                            <h6 class="mb-1">
                                Peek Zoo
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S1 <span class="dots"></span> E22
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 260px;">
                            <h6 class="mb-1">
                                The Maury Show
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S12 <span class="dots"></span> E32
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 260px;">
                            <h6 class="mb-1">
                                The Jerry Springer Show
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S1 <span class="dots"></span> E12
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 520px;">
                            <h6 class="mb-1">
                                The Jerry Springer Show
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S1 <span class="dots"></span> E12
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 260px;">
                            <h6 class="mb-1">
                                Hot Love Affairs
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S2 <span class="dots"></span> E20
                            </p>
                        </div>
                    </div>
                </div>
                <div class="channelsgriddetailrow">
                    <div class="grid-poster">
                        <div class="ratio-slider ratio-2-3">
                            <img src="https://d1tcjcrle6fjgd.cloudfront.net/thumbnails/1609414287230.jpg" />
                        </div>
                    </div>
                    <div class="channelshow-details">
                        <h5 class="mb-2 font-bold">
                            LIT Entertainnment News
                        </h5>
                        <p class="text-secondary mb-2">
                            Now on LIT — 41 min left
                        </p>
                        <button type="button" class="btn btn-theme">Watch Now</button>
                        <p class="text-secondary mb-0">
                            The destination for celebrity and entertainment news, LIT snoops, scoops and breaks
                            exclusives live.
                        </p>
                    </div>
                </div>
            </div>
            <div class="channelsgrid-list-box">
                <div class="chanelshow-list">
                    <div class="channel-logo-box">
                        <div class="logo-img">
                            <img src="https://i.pinimg.com/originals/58/1a/a1/581aa1c0880da28abe537f4974f817dd.png" />
                        </div>
                    </div>
                    <div class="channel-grid-row">
                        <div class="channel-grid-colm" style="width: 320px;">
                            <h6 class="mb-1">
                                The Jerry Springer Show
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S1 <span class="dots"></span> E12
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 200px;">
                            <h6 class="mb-1">
                                Peek Zoo
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S1 <span class="dots"></span> E22
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 260px;">
                            <h6 class="mb-1">
                                The Maury Show
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S12 <span class="dots"></span> E32
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 260px;">
                            <h6 class="mb-1">
                                The Jerry Springer Show
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S1 <span class="dots"></span> E12
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 520px;">
                            <h6 class="mb-1">
                                The Jerry Springer Show
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S1 <span class="dots"></span> E12
                            </p>
                        </div>
                        <div class="channel-grid-colm" style="width: 260px;">
                            <h6 class="mb-1">
                                Hot Love Affairs
                            </h6>
                            <p class="mb-0 text-secondary d-flex align-items-center">
                                S2 <span class="dots"></span> E20
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>